import React from 'react';

interface TypingIndicatorProps {
  providerId: string;
  aiLogo?: string;
  aiColor?: string;
  isSearching?: boolean; // Nova prop para indicar busca na web
}

export function TypingIndicator({ providerId, aiLogo, aiColor, isSearching }: TypingIndicatorProps) {
  // Função para renderizar a logo PNG baseada no providerId
  const renderAILogo = () => {
    switch (providerId) {
      case 'openai':
        return (
          <img 
            src="/gpt-logo.png?v=1" 
            alt="GPT Logo" 
            className="w-5 h-5 object-contain" 
            style={{ maxWidth: '20px', maxHeight: '20px' }}
          />
        );
      case 'anthropic':
        return (
          <img 
            src="/claude-logo.png?v=1" 
            alt="Claude Logo" 
            className="w-5 h-5 object-contain"
            style={{ maxWidth: '20px', maxHeight: '20px' }}
          />
        );
      case 'google':
        return (
          <img 
            src="/gemini-logo.png?v=1" 
            alt="Gemini Logo" 
            className="w-5 h-5 object-contain"
            style={{ maxWidth: '20px', maxHeight: '20px' }}
          />
        );
      default:
        return aiLogo;
    }
  };

  return (
    <div className="max-w-[70%] space-y-2">
      {/* Logo pequena da IA */}
      <div className="flex justify-start">
        <div className="w-5 h-5">
          {renderAILogo()}
        </div>
      </div>
      
      {/* Indicador de busca na web (se estiver buscando) */}
      {isSearching && (
        <div className="flex justify-start mb-2">
          <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 flex items-center space-x-2">
            <svg className="w-4 h-4 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm text-blue-700">🔍 Buscando na web...</span>
          </div>
        </div>
      )}
      
      {/* Bolinha piscando preta */}
      <div className="flex justify-start">
        <div 
          className="w-2 h-2 bg-black rounded-full animate-pulse"
        />
      </div>
    </div>
  );
}
